export default function AppSection() {
  return (
    <section id="app" className="w-full py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="bg-background-100 rounded-2xl p-6 md:p-10 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-3">
              移动端随时畅享
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              每日大赛入口全面适配手机、平板等移动设备，无需下载APP，通过浏览器即可享受流畅高清的每日大赛在线观看体验。通勤路上、午休时间，随时随地畅享精彩赛事视频。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-200 text-xs text-foreground-700 whitespace-nowrap">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-android-line text-sm"></i>
                </span>
                Android 支持
              </span>
              <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-200 text-xs text-foreground-700 whitespace-nowrap">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-apple-line text-sm"></i>
                </span>
                iOS 支持
              </span>
              <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-200 text-xs text-foreground-700 whitespace-nowrap">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-computer-line text-sm"></i>
                </span>
                电脑端支持
              </span>
            </div>
          </div>
          <div className="flex-shrink-0 w-48 md:w-56">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20sports%20competition%20video%20interface%20with%20warm%20coral%20and%20white%20color%20scheme%2C%20clean%20minimal%20UI%20design%2C%20floating%20phone%20on%20simple%20warm%20background%2C%20professional%20product%20photography%2C%20soft%20lighting&width=500&height=800&seq=app-mobile-visual&orientation=portrait"
              alt="每日大赛入口移动端观看"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
}